import esTranslations from "./es";
import enTranslations from "./en";
import ptTranslations from "./pt";
import frTranslations from "./fr";
import arTranslations from "./ar";

const messages = {
  es: {
    translations: esTranslations
  },
  en: {
    translations: enTranslations
  },
  pt: {
    translations: ptTranslations
  },
  fr: {
    translations: frTranslations
  },
  ar: {
    translations: arTranslations
  },
};

export { messages };
